/**
 * Canonical training material MIME + extension rules (shared with **backend-api**).
 *
 * The JSON file lives under **`backend_app`** so operators ship one list with the Lambda bundle;
 * this module re-imports it for the organizer wizard file picker.
 */
import raw from "../../../backend-api/backend_app/training_material_formats.json";

export type TrainingMaterialFormats = {
  filePickerAccept: string;
  uiSummary: string;
  pairs: Array<{ contentType: string; extension: string }>;
};

export const TRAINING_MATERIAL_FORMATS: TrainingMaterialFormats = raw;
